import * as Header from './header/headerReducers';
import * as Invoices from './invoices/invoicesReducers';
import * as News from './news/newsReducers';
import * as Opportunities from './opportuneties/opportunetisReducers';
import * as Order from './order/orderReducers';
import * as Projects from './projects/projectsReducers';
import * as Quotes from './quotes/quotesReducers';
import * as Shipments from './shipment/shiptmentReducers';
import * as User from './user/userReducers';

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    header: Header.reducer,
    quotes: Quotes.reducer,
    news: News.reducer,
    user: User.reducer,
    order: Order.reducer,
    invoices: Invoices.reducer,
    projects: Projects.reducer,
    opportunities: Opportunities.reducer,
    shipments: Shipments.reducer
};



// WEBPACK FOOTER //
// ./src/data/rootReducers.ts